export default "__VITE_ASSET__8jj84H4U__"